var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRwanda(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0002C0 18.7721 0.705188 21.3792 1.94544 23.6524L16 25.0437L30.0546 23.6524C31.2948 21.3792 32 18.7721 32 16.0002L16 14.6089L0 16.0002Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0546 8.34781C27.3409 3.37431 22.0647 0 16 0C9.93531 0 4.65912 3.37431 1.94544 8.34781C0.705188 10.621 0 13.2281 0 16H32C32 13.2281 31.2948 10.621 30.0546 8.34781Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 31.9999C22.0648 31.9999 27.341 28.6256 30.0547 23.6521H1.94556C4.65924 28.6256 9.93543 31.9999 16.0001 31.9999Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0874 9.36367L20.0415 10.2829L19.001 12.1754L21.1228 11.7695L21.3917 13.9129L22.8696 12.3364L24.3476 13.9129L24.6164 11.7695L26.7383 12.1752L25.6978 10.2828L27.6518 9.36367L25.6977 8.44461L26.7383 6.55211L24.6165 6.95798L24.3475 4.81454L22.8696 6.39104L21.3917 4.81454L21.1228 6.95798L19.0009 6.55211L20.0415 8.44467L18.0874 9.36367Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRwanda);
export default __webpack_public_path__ + "static/media/rwanda.af0aa44a.svg";
export { ForwardRef as ReactComponent };